import { FC, HTMLAttributes, useState } from "react";
import { useStyles } from "./Support.style";
import { Typography } from "../../components/core/Typography/Typography";
import { TypographyVariant } from "../../constants/typography";
import AppBar from "../../components/common/AppBar/AppBar";
import { Icon } from "../../components/core/Icon/Icon";
import GamingLoading from "../../components/common/GamingLoading/GamingLoading";
import { HistoryGaming } from "../../models/historyGaming";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../components/hooks";
import i18next from "i18next";
import { getLanguages } from "../../models/settings";

export const Support: FC<
  HTMLAttributes<HTMLDivElement> & {
    type: "privacy" | "term" | "faq" | "cookie";
  }
> = ({ type }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoadingIframe, setLoadingIframe] = useState(true);
  const { theme } = useAppSelector((x) => x.theme);
  const getSupportUrl = () => {
    const dataSupport =
      theme.legalDocuments?.[i18next.language] ||
      theme.legalDocuments?.[getLanguages().default] ||
      {};

    switch (type) {
      case "privacy":
        return {
          name: "Privacy policy",
          url: dataSupport?.privacyPolicy,
        };
      case "term":
        return {
          name: "Terms and conditions",
          url: dataSupport?.termsAndConditions,
        };
      case "faq":
        return {
          name: "FAQ",
          url: dataSupport?.faq,
        };
      case "cookie":
        return {
          name: "Cookie policy",
          url: dataSupport?.cookiePolicy,
        };
    }
  };

  return (
    <div className={classes.root}>
      <AppBar
        leftItems={
          <Icon
            name="icon-bold-arrow-left-3"
            onClick={() => HistoryGaming.back(navigate)}
          />
        }
        centerItems={
          <Typography variant={TypographyVariant.BodyB4Medium}>
            {getSupportUrl().name}
          </Typography>
        }
      />
      {isLoadingIframe && <GamingLoading />}
      <iframe
        onLoad={() => setLoadingIframe(false)}
        id="documentation"
        className={classes.iframe}
        src={getSupportUrl().url}
        title={getSupportUrl().name}
      ></iframe>
    </div>
  );
};
